/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDropTraceItem } from '../models/ApiDropTraceItem';
import { ApiDropWithoutWave } from '../models/ApiDropWithoutWave';
import { ApiWaveMin } from '../models/ApiWaveMin';
import { HttpFile } from '../http/http';

export class ApiWaveDropsFeed {
    'wave': ApiWaveMin;
    'drops': Array<ApiDropWithoutWave>;
    'root_drop'?: ApiDropWithoutWave;
    'trace'?: Array<ApiDropTraceItem>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "wave",
            "baseName": "wave",
            "type": "ApiWaveMin",
            "format": ""
        },
        {
            "name": "drops",
            "baseName": "drops",
            "type": "Array<ApiDropWithoutWave>",
            "format": ""
        },
        {
            "name": "root_drop",
            "baseName": "root_drop",
            "type": "ApiDropWithoutWave",
            "format": ""
        },
        {
            "name": "trace",
            "baseName": "trace",
            "type": "Array<ApiDropTraceItem>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveDropsFeed.attributeTypeMap;
    }

    public constructor() {
    }
}

